/*eslint-disable */
export default {
	namespaced: true,
	state: {
		search_value: '',
	},
	mutations: {
		SET_STATE(state, {propName, value}) {
			state[propName] = value;
		},
		SET_SEARCH_VALUE(state, search_value) {
			state.search_value = search_value;
		},
	},
	actions: {},
	getters: {},
}
